"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayNodeDependencies = void 0;
var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var ArrayNodeDependencies = exports.ArrayNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  createArrayNode: _factoriesAny.createArrayNode
};